/*============================================================================
  Conceptoline — theme.js
  Interacțiuni: meniu full-screen, cart drawer (AJAX), căutare, slidere
  cu scroll-snap, accordion, selector de variante, back-to-top.
  Fără dependențe externe.
============================================================================*/
(function () {
  'use strict';

  const root = document.documentElement;
  const body = document.body;
  const $ = (s, c = document) => c.querySelector(s);
  const $$ = (s, c = document) => Array.from(c.querySelectorAll(s));

  // Prefixul de limbă al storefrontului: '/' pe RO (limba default), '/en/' pe EN.
  // OBLIGATORIU pe toate cererile AJAX (2026-08-05): fără el, /cart/*.js și
  // ?section_id=… se randează în limba DEFAULT, așa că pe /en coșul revenea în
  // română. Shopify.routes.root e injectat de platformă în orice storefront.
  const ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  function money(cents) {
    // Sub Shopify Markets, prețurile vin în moneda pieței (EUR/USD/GBP), dar
    // shop.money_format e formatul monedei magazinului (RON). Dacă cele două
    // diferă, formatăm cu Intl pe moneda activă — altfel un preț în EUR apărea
    // scris „lei" (2026-08-05).
    const active = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || null;
    const shopCur = (window.themeStrings && window.themeStrings.shopCurrency) || null;
    if (active && shopCur && active !== shopCur && typeof Intl !== 'undefined') {
      try {
        return new Intl.NumberFormat(root.lang || undefined, {
          style: 'currency', currency: active
        }).format(Number(cents) / 100);
      } catch (e) { /* monedă necunoscută → cădem pe formatul de mai jos */ }
    }
    const fmt = (window.themeStrings && window.themeStrings.moneyFormat) || '{{amount}}';
    function fmtNum(n, dec, ts, ds) {
      n = (Number(n) / 100).toFixed(dec);
      let parts = n.split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ts);
      return parts[1] ? parts[0] + ds + parts[1] : parts[0];
    }
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/g, function (m, name) {
      switch (name) {
        case 'amount_no_decimals': return fmtNum(cents, 0, ',', '.');
        case 'amount_with_comma_separator': return fmtNum(cents, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return fmtNum(cents, 0, '.', ',');
        case 'amount_with_space_separator': return fmtNum(cents, 2, ' ', ',');
        case 'amount_no_decimals_with_space_separator': return fmtNum(cents, 0, ' ', ',');
        default: return fmtNum(cents, 2, ',', '.');
      }
    });
  }

  // Markup partajat pentru preț redus (compare + sale + badge "% off"),
  // ținut identic cu snippets/price.liquid ca re-randările client-side
  // să nu piardă badge-ul.
  function salePriceHTML(price, cmp) {
    let h =
      '<span class="price__compare">' + money(cmp) + '</span>' +
      '<span class="price__sale">' + money(price) + '</span>';
    const pct = Math.round((cmp - price) * 100 / cmp);
    if (pct >= 1) h += '<span class="price__off">' + pct + '% off</span>';
    return h;
  }

  // Drawers (meniu/căutare/coș), overlay, submeniuri și Escape sunt gestionate
  // de rebrand.js (sistemul .rb-*). theme.js doar deschide coșul după add (openCart).

  /*-------------------------------------------------- Sliders --------*/
  $$('.ct-slider').forEach((slider) => {
    const track = $('.ct-slider__track', slider);
    const prev = $('.ct-slider__arrow--prev', slider);
    const next = $('.ct-slider__arrow--next', slider);
    if (!track) return;
    const step = () => track.clientWidth * 0.8;
    const update = () => {
      if (!prev || !next) return;
      prev.toggleAttribute('disabled', track.scrollLeft <= 4);
      next.toggleAttribute(
        'disabled',
        track.scrollLeft + track.clientWidth >= track.scrollWidth - 4
      );
    };
    if (prev) prev.addEventListener('click', () => track.scrollBy({ left: -step(), behavior: 'smooth' }));
    if (next) next.addEventListener('click', () => track.scrollBy({ left: step(), behavior: 'smooth' }));
    track.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    update();
  });

  /*----------- Săgeți carusel pe feed-ul de home (desktop) -----------*/
  /* Glisează banda orizontală [data-feed-track]; scroll-ul declanșează
     încărcarea infinită (IO cu root = track, definit mai jos). Săgețile
     sunt ascunse pe mobil prin CSS — acolo rămâne swipe-ul nativ. */
  $$('.rb-feed').forEach((feed) => {
    const track = $('[data-feed-track]', feed);
    const prev = $('[data-feed-arrow="prev"]', feed);
    const next = $('[data-feed-arrow="next"]', feed);
    if (!track || (!prev && !next)) return;
    const step = () => Math.max(track.clientWidth * 0.9, 240);
    const update = () => {
      if (prev) prev.toggleAttribute('disabled', track.scrollLeft <= 4);
      if (next) {
        next.toggleAttribute(
          'disabled',
          track.scrollLeft + track.clientWidth >= track.scrollWidth - 4
        );
      }
    };
    if (prev) prev.addEventListener('click', () => track.scrollBy({ left: -step(), behavior: 'smooth' }));
    if (next) next.addEventListener('click', () => track.scrollBy({ left: step(), behavior: 'smooth' }));
    track.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    update();
  });

  /*---------------------------------- Galerie produs (thumbs) --------*/
  $$('[data-gallery]').forEach((gallery) => {
    const main = $('[data-gallery-main]', gallery);
    $$('[data-gallery-thumb]', gallery).forEach((thumb) => {
      thumb.addEventListener('click', () => {
        const src = thumb.getAttribute('data-src');
        if (main && src) main.src = src;
        $$('[data-gallery-thumb]', gallery).forEach((t) => t.classList.remove('is-active'));
        thumb.classList.add('is-active');
      });
    });
  });

  /*------------------ Produs: variante + add to cart (root-scoped) ---*/
  // Blocurile OS 2.0 sunt frați în DOM: radio-urile de variantă sunt în
  // afara <form>-ului, deci lucrăm la nivel de [data-product-root].
  $$('[data-product-root]').forEach((root) => {
    const form = $('[data-product-form]', root);
    const dataEl = $('[data-product-json]', root);
    let product = null;
    try { product = dataEl ? JSON.parse(dataEl.textContent) : null; } catch (e) {}
    const priceEl = $('[data-product-price]', root);
    const idInput = form ? $('[name="id"]', form) : null;
    const addBtn = form ? $('[data-add-to-cart]', form) : null;
    const stockEl = $('[data-stock-root]', root);
    const lowThreshold = parseInt(root.getAttribute('data-low-threshold'), 10) || 5;
    let inventory = {};
    const invEl = $('[data-inventory-json]', root);
    try { inventory = invEl ? JSON.parse(invEl.textContent) : {}; } catch (e) {}
    const errEl = $('[data-cart-error]', root);

    function currentVariant() {
      if (!product || !product.variants) return null;
      const groups = $$('[data-option-position]', root);
      // Produsele fără opțiuni reale (Shopify: has_only_default_variant) nu randează
      // niciun grup de variante — main-product.liquid le sare cu `unless`. Fără linia
      // asta, potrivirea de mai jos compara „Default Title" cu undefined, nu găsea
      // nimic și butonul rămânea „Indisponibil", adică produsul era necumpărabil.
      if (!groups.length) return product.variants[0] || null;
      const opts = [];
      groups.forEach((group) => {
        const checked = group.querySelector('input:checked') || group.querySelector('select');
        const pos = parseInt(group.getAttribute('data-option-position'), 10) - 1;
        if (checked) opts[pos] = checked.value;
      });
      return product.variants.find((v) => v.options.every((o, i) => o === opts[i])) || null;
    }

    function renderPrice(variant) {
      if (!priceEl) return;
      const cmp = variant.compare_at_price;
      const onSale = cmp && cmp > variant.price;
      let inner = '<span class="price__regular">' + money(variant.price) + '</span>';
      if (onSale) {
        inner = salePriceHTML(variant.price, cmp);
      }
      priceEl.innerHTML =
        '<span class="price' + (onSale ? ' price--on-sale' : '') + '">' + inner + '</span>';
    }

    // Citește inventarul REAL per-variantă (emis server-side) și actualizează
    // mesajul de stoc; avertizează când stocul gestionat e sub prag.
    function renderStock(variant, isPre) {
      if (!stockEl) return;
      const msg = stockEl.querySelector('[data-stock-msg]') || stockEl;
      msg.classList.remove('product__stock--low', 'product__stock--out');
      if (!variant || !variant.available) {
        msg.classList.add('product__stock--out');
        msg.textContent = (window.themeStrings && window.themeStrings.soldOut) || 'Stoc epuizat';
        return;
      }
      if (isPre) {
        msg.textContent = (window.themeStrings && window.themeStrings.preorderStock) || 'Disponibil la precomandă';
        return;
      }
      const info = inventory[variant.id];
      const managed = info && info.managed && info.policy !== 'continue';
      const qty = info ? info.qty : 0;
      if (managed && qty > 0 && qty <= lowThreshold) {
        msg.classList.add('product__stock--low');
        const tmpl = (window.themeStrings && window.themeStrings.onlyLeft) || 'Doar {count} în stoc';
        msg.textContent = tmpl.replace('__count__', qty).replace('{count}', qty);
      } else {
        msg.textContent = (window.themeStrings && window.themeStrings.inStock) || 'În stoc · livrare rapidă';
      }
    }

    // Marchează vizual valorile de opțiune care nu duc la o variantă disponibilă
    // (ex. o mărime epuizată pentru culoarea selectată).
    function updateOptionAvailability() {
      if (!product || !product.variants) return;
      const opts = [];
      $$('[data-option-position]', root).forEach((group) => {
        const checked = group.querySelector('input:checked') || group.querySelector('select');
        const pos = parseInt(group.getAttribute('data-option-position'), 10) - 1;
        if (checked) opts[pos] = checked.value;
      });
      $$('[data-option-position]', root).forEach((group) => {
        const pos = parseInt(group.getAttribute('data-option-position'), 10) - 1;
        $$('[data-variant-option]', group).forEach((input) => {
          const candidate = opts.slice();
          candidate[pos] = input.value;
          const ok = product.variants.some((v) => v.available && v.options.every((o, i) => o === candidate[i]));
          const label = input.nextElementSibling || root.querySelector('label[for="' + input.id + '"]');
          if (label) label.classList.toggle('is-unavailable', !ok);
        });
      });
    }

    // Galeria pe CULOARE (2026-08-03): arată doar imaginile culorii selectate.
    // Etichetele vin server-side (data-media-color: alt-prefix sau imagine de
    // variantă); media fără etichetă aparține culorii „primare" (data-primary-color);
    // o culoare fără nicio media etichetată vede întreaga galerie (fallback sigur).
    function filterGalleryByColor() {
      const gal = root.querySelector('[data-gallery]');
      if (!gal) return;
      const colorInput = root.querySelector('.variant-group--color input:checked');
      const frames = $$('[data-media-color]', gal);
      if (!colorInput || !frames.length) return;
      const c = colorInput.value.toLowerCase();
      const primary = (gal.getAttribute('data-primary-color') || '').toLowerCase();
      const hasTagged = frames.some((f) => f.getAttribute('data-media-color') === c);
      frames.forEach((f) => {
        const t = f.getAttribute('data-media-color');
        const show = !hasTagged || t === c || (c === primary && t === '');
        f.hidden = !show;
      });
      // caruselul mobil: dash-ul și poziția se refac pe noul set vizibil
      const track = gal.querySelector('[data-card-track]');
      if (track) {
        track.scrollLeft = 0;
        const dash = gal.querySelector('[data-card-dash]');
        if (dash) {
          const visible = $$('[data-media-color]', track).filter((f) => !f.hidden).length;
          if (visible > 0) dash.style.width = 'calc(100% / ' + visible + ')';
        }
      }
    }

    function refresh() {
      if (!product) return;
      updateOptionAvailability();
      filterGalleryByColor();
      const variant = currentVariant();
      if (!variant) {
        if (addBtn) {
          addBtn.disabled = true;
          addBtn.textContent = (window.themeStrings && window.themeStrings.unavailable) || 'Indisponibil';
        }
        renderStock(null);
        return;
      }
      if (idInput) idInput.value = variant.id;
      // Sincronizează rândul „produsul curent" din FBT cu varianta aleasă,
      // altfel selecția adaugă în coș varianta inițială (greșită).
      const fbtCurrent = root.querySelector('[data-fbt-current]');
      if (fbtCurrent) {
        fbtCurrent.value = variant.id;
        fbtCurrent.setAttribute('data-price', variant.price);
        const fbtRow = fbtCurrent.closest('.product__fbt-item');
        const fbtRowPrice = fbtRow && fbtRow.querySelector('.product__fbt-price');
        if (fbtRowPrice) {
          const fbtCmp = variant.compare_at_price;
          const fbtSale = fbtCmp && fbtCmp > variant.price;
          let fbtInner = '<span class="price__regular">' + money(variant.price) + '</span>';
          if (fbtSale) {
            fbtInner = salePriceHTML(variant.price, fbtCmp);
          }
          fbtRowPrice.innerHTML = '<div class="price' + (fbtSale ? ' price--on-sale' : '') + '">' + fbtInner + '</div>';
        }
        fbtCurrent.dispatchEvent(new Event('change', { bubbles: true }));
      }
      renderPrice(variant);
      // Precomandă (#29 + fix 2026-08-03): inputul [data-preorder-prop] există doar la
      // produsele cu custom.precomanda=true; starea per variantă (stoc gestionat ≤ 0,
      // dar cumpărabilă prin „continue selling") comută eticheta și proprietatea.
      const invInfo = inventory[variant.id];
      // querySelectorAll, nu querySelector: de la 2026-08-13 sunt DOUĂ proprietăți
      // („Precomandă" și „Livrare estimată"), amândouă trebuie comutate.
      const preorderProps = root.querySelectorAll('[data-preorder-prop]');
      const isPre = preorderProps.length > 0 && variant.available && !!invInfo && !!invInfo.managed && invInfo.qty <= 0;
      preorderProps.forEach((el) => { el.disabled = !isPre; });
      const etaEl = root.querySelector('[data-preorder-eta]');
      if (etaEl) etaEl.hidden = !isPre;
      renderStock(variant, isPre);
      if (addBtn) {
        addBtn.disabled = !variant.available;
        addBtn.textContent = !variant.available
          ? ((window.themeStrings && window.themeStrings.soldOut) || 'Stoc epuizat')
          : isPre
            ? ((window.themeStrings && window.themeStrings.preorder) || 'Precomandă')
            : ((window.themeStrings && window.themeStrings.addToCart) || 'Adaugă în coș');
      }
    }

    root.addEventListener('change', (e) => {
      if (e.target.closest('[data-option-position]')) refresh();
    });
    refresh();

    if (form) {
      form.addEventListener('submit', async (e) => {
        e.preventDefault();
        if (addBtn) addBtn.disabled = true;
        try {
          // Proprietățile de linie (Precomandă, Livrare estimată) se citesc din
          // formular, nu se scriu de mână: FormData sare automat peste input-urile
          // `disabled`, exact cum le comută refresh() per variantă. Înainte payload-ul
          // avea doar id+quantity, deci nicio proprietate n-ajungea vreodată în coș.
          const formData = new FormData(form);
          const properties = {};
          formData.forEach((value, key) => {
            const match = key.match(/^properties\[(.+)\]$/);
            if (match && String(value).trim() !== '') properties[match[1]] = value;
          });
          const payload = {
            id: idInput ? idInput.value : null,
            quantity: parseInt((form.querySelector('[name="quantity"]') || {}).value || 1, 10),
          };
          if (Object.keys(properties).length) payload.properties = properties;
          const res = await fetch(ROOT + 'cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify(payload),
          });
          if (!res.ok) {
            let msg = '';
            try { const data = await res.json(); msg = data.description || data.message || ''; } catch (e2) {}
            if (errEl) { errEl.textContent = msg || ((window.themeStrings && window.themeStrings.addError) || 'Nu am putut adăuga produsul în coș.'); errEl.hidden = false; }
            return;
          }
          if (errEl) errEl.hidden = true;
          await refreshCart();
          openCart();
        } catch (err) {
          location.href = '/cart';
        } finally {
          if (addBtn) addBtn.disabled = false;
        }
      });
    }
  });

  /*------------------------ Frequently bought together (PDP) ---------*/
  $$('[data-fbt]').forEach((fbt) => {
    const totalEl = $('[data-fbt-total]', fbt);
    const addBtn = $('[data-fbt-add]', fbt);
    const items = () => $$('[data-fbt-item]', fbt);
    function updateTotal() {
      let total = 0;
      items().forEach((i) => { if (i.checked) total += parseInt(i.getAttribute('data-price'), 10) || 0; });
      if (totalEl) totalEl.textContent = money(total);
    }
    fbt.addEventListener('change', (e) => { if (e.target.closest('[data-fbt-item]')) updateTotal(); });
    if (addBtn) {
      addBtn.addEventListener('click', async () => {
        const chosen = items().filter((i) => i.checked).map((i) => ({ id: i.value, quantity: 1 }));
        if (!chosen.length) return;
        addBtn.disabled = true;
        try {
          const res = await fetch(ROOT + 'cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ items: chosen }),
          });
          if (!res.ok) throw new Error('fbt add');
          await refreshCart();
          openCart();
        } catch (err) {
          location.href = '/cart';
        } finally {
          addBtn.disabled = false;
        }
      });
    }
    updateTotal();
  });

  /*--------------------------------------------- Cart drawer ---------*/
  // Sertarul live e `.rb-cartd` (sistemul rebrand). Deschiderea/închiderea
  // sunt gestionate de rebrand.js; aici doar deschidem după add-to-cart.
  function openCart() {
    const drawer = $('.rb-cartd');
    if (!drawer) return;
    drawer.classList.add('is-open');
    const overlay = $('.rb-overlay');
    if (overlay) overlay.classList.add('is-active');
    body.style.overflow = 'hidden';
  }
  window.openCart = openCart;

  async function refreshCart() {
    try {
      const res = await fetch(ROOT + '?section_id=cart-drawer');
      if (res.ok) {
        const html = await res.text();
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const fresh = doc.querySelector('.rb-cartd');
        const current = $('.rb-cartd');
        if (fresh && current) current.innerHTML = fresh.innerHTML;
      }
      // #2 (2026-07-23): pe /cart re-randăm și pagina coșului (Section Rendering API),
      // altfel lista/subtotalul vizibile pe pagină rămân vechi după modificări.
      // (Interacțiunile din pagină sunt delegate pe document, deci supraviețuiesc.)
      const mc = document.querySelector('[data-main-cart]');
      if (mc && mc.getAttribute('data-section-id')) {
        const pageRes = await fetch(location.pathname + '?section_id=' + mc.getAttribute('data-section-id'));
        if (pageRes.ok) {
          const pageDoc = new DOMParser().parseFromString(await pageRes.text(), 'text/html');
          const freshPage = pageDoc.querySelector('[data-main-cart]');
          if (freshPage) {
            // Nota tastată dar netrimisă ar dispărea la înlocuirea innerHTML — o păstrăm.
            const noteEl = mc.querySelector('[name="note"]');
            const noteVal = noteEl ? noteEl.value : null;
            mc.innerHTML = freshPage.innerHTML;
            const newNote = mc.querySelector('[name="note"]');
            if (newNote && noteVal !== null) newNote.value = noteVal;
          }
        }
      }
      // Contorul din header nu e inclus în markup-ul secțiunii cart-drawer,
      // deci îl luăm din /cart.js.
      const cartRes = await fetch(ROOT + 'cart.js', { headers: { Accept: 'application/json' } });
      if (cartRes.ok) {
        const cart = await cartRes.json();
        $$('[data-cart-count]').forEach((c) => { c.textContent = cart.item_count; });
      }
    } catch (e) {}
  }
  window.refreshCart = refreshCart;

  // Toast scurt (ex. informare stoc insuficient). Literale de culoare — trăiește pe <body>.
  function showCartToast(msg) {
    let t = document.getElementById('rb-cart-toast');
    if (!t) { t = document.createElement('div'); t.id = 'rb-cart-toast'; t.className = 'rb-cart-toast'; document.body.appendChild(t); }
    t.textContent = msg;
    // reflow ca să re-pornească tranziția
    void t.offsetWidth; t.classList.add('is-visible');
    clearTimeout(t._timer);
    t._timer = setTimeout(() => t.classList.remove('is-visible'), 3800);
  }
  window.showCartToast = showCartToast;

  document.addEventListener('click', async (e) => {
    const change = e.target.closest('[data-cart-change]');
    if (!change) return;
    e.preventDefault();
    const line = change.getAttribute('data-line');
    const qty = parseInt(change.getAttribute('data-cart-change'), 10);
    try {
      const res = await fetch(ROOT + 'cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ line: parseInt(line, 10), quantity: qty }),
      });
      if (res.ok) {
        let cart = null; try { cart = await res.json(); } catch (er) {}
        await refreshCart();
        // Stoc: dacă am cerut mai mult decât s-a aplicat, Shopify plafonează tăcut → informăm.
        if (cart && cart.items) {
          const it = cart.items[parseInt(line, 10) - 1];
          if (it && qty > it.quantity) {
            const max = it.quantity;
            const tmpl = (window.themeStrings && window.themeStrings.stockLimitMax) ||
              'Stoc insuficient — cantitatea maximă disponibilă este __count__.';
            showCartToast(tmpl.replace('__count__', max));
          }
        }
      } else {
        // 422 etc. — cererea a fost respinsă (de obicei stoc insuficient). Informăm clientul.
        await refreshCart();
        showCartToast((window.themeStrings && window.themeStrings.stockLimit) ||
          'Nu mai putem adăuga — stoc insuficient pentru acest produs.');
      }
    } catch (err) {}
  });

  // „Notifică-mă când revine în stoc" (#30): deschide panoul cu formularul.
  document.addEventListener('click', (e) => {
    const t = e.target.closest('[data-notify-toggle]');
    if (!t) return;
    const root = t.closest('[data-product-root]') || document;
    const panel = root.querySelector('[data-notify-panel]');
    if (!panel) return;
    const opening = panel.hasAttribute('hidden');
    if (opening) panel.removeAttribute('hidden'); else panel.setAttribute('hidden', '');
    t.setAttribute('aria-expanded', opening ? 'true' : 'false');
  });

  // FBT (#2, 2026-07-23): „+" pe un produs multi-variantă deschide panoul de
  // mărimi randat server-side; pill-urile poartă data-sugg-add cu varianta aleasă.
  // Delegat pe document — refreshCart() înlocuiește innerHTML-ul drawerului.
  const closeSuggPanels = (except) => {
    $$('[data-sugg-panel]:not([hidden])').forEach((p) => {
      if (p === except) return;
      p.setAttribute('hidden', '');
      const root = p.closest('[data-sugg-root]');
      const btn = root && root.querySelector('[data-sugg-open]');
      if (btn) btn.setAttribute('aria-expanded', 'false');
    });
  };
  document.addEventListener('click', (e) => {
    const opener = e.target.closest('[data-sugg-open]');
    if (!opener) {
      // click în afara oricărui rând de sugestie → închide panourile deschise
      if (!e.target.closest('[data-sugg-root]')) closeSuggPanels();
      return;
    }
    e.preventDefault();
    const root = opener.closest('[data-sugg-root]');
    const panel = root && root.querySelector('[data-sugg-panel]');
    if (!panel) return;
    const opening = panel.hasAttribute('hidden');
    closeSuggPanels(panel);
    if (opening) panel.removeAttribute('hidden'); else panel.setAttribute('hidden', '');
    opener.setAttribute('aria-expanded', opening ? 'true' : 'false');
  });

  // Recomandări din sertar (FBT): adăugare reală prin AJAX (fallback: form POST).
  document.addEventListener('click', async (e) => {
    const sugg = e.target.closest('[data-sugg-add]');
    if (!sugg) return;
    e.preventDefault();
    const id = sugg.getAttribute('data-sugg-add');
    if (!id) return;
    sugg.disabled = true;
    try {
      const res = await fetch(ROOT + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: id, quantity: 1 }),
      });
      if (res.ok) await refreshCart();
    } catch (err) {
    } finally {
      sugg.disabled = false;
    }
  });

  /*------------------------------------------------ Accordion --------*/
  // <details> native — nimic de făcut, dar permitem doar unul deschis pe grup
  $$('[data-accordion-single]').forEach((group) => {
    $$('details', group).forEach((d) => {
      d.addEventListener('toggle', () => {
        if (d.open) $$('details', group).forEach((o) => { if (o !== d) o.open = false; });
      });
    });
  });

  // Back-to-top (.rb-totop) e gestionat de rebrand.js.

  /*---------------------------------------------- Wishlist -----------*/
  // Wishlist simplu pe localStorage (placeholder până la o app dedicată)
  const WKEY = 'ct_wishlist';
  const getWish = () => { try { return JSON.parse(localStorage.getItem(WKEY)) || []; } catch (e) { return []; } };
  const setWish = (a) => localStorage.setItem(WKEY, JSON.stringify(a));
  function paintWish() {
    const list = getWish();
    $$('[data-wishlist-toggle]').forEach((b) =>
      b.classList.toggle('is-active', list.includes(b.getAttribute('data-handle')))
    );
    $$('[data-wishlist-count]').forEach((c) => (c.textContent = list.length ? list.length : ''));
  }
  document.addEventListener('click', (e) => {
    const b = e.target.closest('[data-wishlist-toggle]');
    if (!b) return;
    e.preventDefault();
    const h = b.getAttribute('data-handle');
    let list = getWish();
    list = list.includes(h) ? list.filter((x) => x !== h) : list.concat(h);
    setWish(list);
    paintWish();
    document.dispatchEvent(new CustomEvent('wishlist:change'));
  });
  paintWish();

  // Header la scroll (.rb-header[data-rb-header]) e gestionat de rebrand.js.

  /*------------------------------------ Reveal la scroll -------------*/
  // Fade-up fin pe blocurile editoriale. Gated pe .js (fără flash) +
  // fallback complet vizibil dacă nu există IntersectionObserver.
  const revealSel = [
    '.featured-collection',
    '.image-with-text',
    '.rich-text',
    '.editorial-tile',
    '.collection-list__grid',
    '.collection-head',
    '.newsletter',
    '.lookbook__media',
    '.lookbook__caption',
    '.feature-banner__content',
    '.complete-look',
    '.outfit-pair',
    '.blog-card',
    '.list-collections__item',
    '.search-result-card',
    '.article__media'
  ].join(',');
  const revealEls = $$(revealSel);
  if ('IntersectionObserver' in window && revealEls.length) {
    revealEls.forEach((el) => el.classList.add('reveal-up'));
    const io = new IntersectionObserver((entries, obs) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-in');
          obs.unobserve(entry.target);
        }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    revealEls.forEach((el) => io.observe(el));
  }

  // Reveal pentru sistemul rebrand (.reveal/.reveal-clip/.kin) — un singur motor
  // de scroll-reveal, în theme.js. getBoundingClientRect + verificări întârziate la
  // încărcare (robust pe toate elementele, inclusiv reveal-clip cu clip-path).
  const rbRevealEls = $$('.reveal, .reveal-clip, .kin, .kin-words');
  const rbReduced = matchMedia('(prefers-reduced-motion: reduce)').matches;
  const checkReveal = () => {
    const vh = window.innerHeight;
    rbRevealEls.forEach((el) => {
      if (el.classList.contains('is-in')) return;
      const r = el.getBoundingClientRect();
      if (r.height === 0) return;
      if (r.top < vh * 0.92 && r.bottom > vh * -0.1) el.classList.add('is-in');
    });
  };
  if (rbReduced) {
    rbRevealEls.forEach((el) => el.classList.add('is-in'));
  } else {
    // Listener-ele se atașează necondiționat: în editor pot apărea ulterior
    // secțiuni rb- pe pagini care porneau fără niciun element de reveal.
    window.addEventListener('scroll', checkReveal, { passive: true });
    window.addEventListener('resize', checkReveal, { passive: true });
    if (rbRevealEls.length) {
      checkReveal();
      [250, 900, 1800, 3000].forEach((t) => setTimeout(checkReveal, t));
    }
  }
  // Editorul de teme injectează/re-randează secțiuni fără reload: elementele noi
  // nu sunt în colecția inițială și ar rămâne ascunse. Le adăugăm și le revelăm.
  document.addEventListener('shopify:section:load', (e) => {
    const scope = e.target || document;
    $$(revealSel, scope).forEach((el) => el.classList.add('reveal-up', 'is-in'));
    const fresh = $$('.reveal, .reveal-clip, .kin, .kin-words', scope);
    if (!fresh.length) return;
    if (rbReduced) { fresh.forEach((el) => el.classList.add('is-in')); return; }
    fresh.forEach((el) => { if (rbRevealEls.indexOf(el) === -1) rbRevealEls.push(el); });
    checkReveal();
    setTimeout(checkReveal, 300);
  });

  /*------------------------------- Titluri de secțiune animate ------*/
  $$('.section-heading').forEach((h) => {
    if (h.querySelector('span')) return;
    h.classList.add('reveal-title');
    h.innerHTML = '<span>' + h.innerHTML + '</span>';
  });
  if ('IntersectionObserver' in window) {
    const tIo = new IntersectionObserver((ents, obs) => {
      ents.forEach((e) => { if (e.isIntersecting) { e.target.classList.add('is-in'); obs.unobserve(e.target); } });
    }, { threshold: 0.5 });
    $$('.section-heading.reveal-title').forEach((h) => tIo.observe(h));
  }

  // Parallax-ul ct (.hero__media[data-parallax]) nu mai e randat — eliminat.
  // Interceptorul de tranziție de pagină (+300ms la fiecare navigare internă) a
  // fost eliminat: naviga­rea e instantanee.

  /*------------------------------------------- Modal (generic) ------*/
  function openModal(sel) { const m = $(sel); if (!m) return; m.classList.add('is-open'); body.classList.add('menu-open'); }
  function closeModal(m) { (m || $('.modal.is-open')) && (m || $('.modal.is-open')).classList.remove('is-open'); if (!$('.menu-drawer.is-open, .cart-drawer.is-open, .search-drawer.is-open')) body.classList.remove('menu-open'); }
  document.addEventListener('click', (e) => {
    const open = e.target.closest('[data-modal-open]');
    if (open) { e.preventDefault(); openModal(open.getAttribute('data-modal-open')); }
    if (e.target.closest('[data-modal-close]') || e.target.classList.contains('modal__backdrop')) {
      const m = e.target.closest('.modal'); if (m) m.classList.remove('is-open');
      if (!$('.menu-drawer.is-open, .cart-drawer.is-open, .search-drawer.is-open')) body.classList.remove('menu-open');
    }
  });
  // Escape face aceeași curățenie ca ramura de click-close: fără ea, body.menu-open
  // (pus de openModal) rămânea agățat și pagina stătea blocată la scroll.
  document.addEventListener('keydown', (e) => {
    if (e.key !== 'Escape') return;
    const m = $('.modal.is-open');
    if (!m) return;
    m.classList.remove('is-open');
    if (!$('.menu-drawer.is-open, .cart-drawer.is-open, .search-drawer.is-open')) body.classList.remove('menu-open');
  });

  /*---------------- Newsletter footer: feedback robust (#11) ---------------*/
  // form.posted_successfully? depinde de ?customer_posted=true, care se poate
  // pierde (ex. flux /challenge). Marcăm submitul în sessionStorage și, dacă
  // Liquid nu a randat confirmarea, o afișăm client-side.
  (() => {
    const FKEY = 'rb-footnews-submitted';
    const footForm = document.getElementById('FooterNewsForm');
    if (footForm) footForm.addEventListener('submit', () => {
      try { sessionStorage.setItem(FKEY, '1'); } catch (e) {}
    });
    let fSub = false;
    try { fSub = sessionStorage.getItem(FKEY) === '1'; if (fSub) sessionStorage.removeItem(FKEY); } catch (e) {}
    if (fSub && footForm && !footForm.querySelector('.rb-footer__newsok')) {
      const ok = document.createElement('p');
      ok.className = 'rb-footer__newsok';
      ok.textContent = (window.themeStrings && window.themeStrings.newsletterSuccess) || 'Mulțumim! Te-ai abonat cu succes.';
      footForm.appendChild(ok);
      const em = footForm.querySelector('input[type=email]');
      if (em) em.value = '';
    }
  })();

  /*------------------- Galerie PDP: video doar în galeria vizibilă (#5) ----*/
  // Galeria există în dublu exemplar (desktop + mobil, comutate prin CSS);
  // display:none NU oprește un <video autoplay> — l-ar streama și pe cel ascuns.
  const syncGalleryVideos = () => {
    $$('.product__gallery video').forEach((v) => {
      const hidden = v.offsetParent === null; // ascuns prin display:none
      if (hidden) {
        if (!v.paused) v.pause();
      } else if (v.paused && v.autoplay) {
        const p = v.play();
        if (p && p.catch) p.catch(() => {});
      }
    });
  };
  if ($('.product__gallery video')) {
    syncGalleryVideos();
    window.addEventListener('resize', syncGalleryVideos);
  }

  /*---------------- Galerie PDP: rail de thumbnails (QA 2026-07-31) ----*/
  // Click pe thumb → scroll lin la poza respectivă din stiva verticală;
  // scroll-spy (IntersectionObserver) ține thumb-ul activ sincron la scroll.
  $$('[data-thumb-rail]').forEach((rail) => {
    if (rail.dataset.thumbBound) return;
    rail.dataset.thumbBound = '1';
    const gallery = rail.closest('.product__gallery');
    if (!gallery) return;
    const imgs = $$('.product__gallery-desktop .product__gallery-vimg', gallery);
    const btns = $$('[data-thumb-go]', rail);
    if (!imgs.length || !btns.length) return;
    // Corelarea thumb ↔ poză se face pe data-media-id, nu pe index — la filtrarea
    // galeriei pe culoare (2026-08-03) indexul nu mai corespunde.
    const setActiveBtn = (btn) => {
      btns.forEach((b) => b.classList.toggle('is-active', b === btn));
    };
    rail.addEventListener('click', (e) => {
      const b = e.target.closest('[data-thumb-go]');
      if (!b) return;
      const id = b.getAttribute('data-media-id');
      const frame = id && gallery.querySelector('.product__gallery-desktop [data-media-id="' + id + '"]');
      const target = (frame && frame.firstElementChild) || imgs[parseInt(b.getAttribute('data-thumb-go'), 10)];
      if (!target) return;
      const y = target.getBoundingClientRect().top + window.scrollY - 90;
      window.scrollTo({ top: y, behavior: 'smooth' });
      setActiveBtn(b);
    });
    if ('IntersectionObserver' in window) {
      const io = new IntersectionObserver((entries) => {
        entries.forEach((en) => {
          if (!en.isIntersecting) return;
          const fr = en.target.closest('[data-media-id]');
          const id = fr && fr.getAttribute('data-media-id');
          const btn = id ? btns.find((b) => b.getAttribute('data-media-id') === id) : btns[imgs.indexOf(en.target)];
          if (btn) setActiveBtn(btn);
        });
      }, { rootMargin: '-35% 0px -55% 0px' });
      imgs.forEach((im) => io.observe(im));
    }
  });

  /*--------------------------- Ghid mărimi: switch CM/INCH (#16) ----*/
  // Delegat pe document (modalul e static în secțiune, dar păstrăm modelul delegat).
  document.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-sg-unit]');
    if (!btn) return;
    const panel = btn.closest('.modal__panel');
    if (!panel) return;
    const unit = btn.getAttribute('data-sg-unit');
    $$('[data-sg-unit]', panel).forEach((b) => {
      const on = b === btn;
      b.classList.toggle('is-active', on);
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
    $$('[data-sg-img]', panel).forEach((img) => {
      img.hidden = img.getAttribute('data-sg-img') !== unit;
    });
  });

  /*-------------------------------------- Zoom / lightbox produs ----*/
  function buildLightbox() {
    let lb = $('.lightbox');
    if (lb) return lb;
    lb = document.createElement('div');
    lb.className = 'lightbox';
    lb.setAttribute('role', 'dialog');
    lb.setAttribute('aria-modal', 'true');
    lb.setAttribute('aria-label', 'Imagine produs');
    lb.innerHTML = '<button class="lightbox__close" aria-label="Închide"><svg viewBox="0 0 24 24" width="26" height="26" fill="none" stroke="currentColor" stroke-width="1.4"><path d="m6 6 12 12M18 6 6 18"/></svg></button><img alt="">';
    body.appendChild(lb);
    const close = () => {
      lb.classList.remove('is-open');
      if (lb._opener) { lb._opener.focus(); lb._opener = null; }
    };
    lb.addEventListener('click', close);
    document.addEventListener('keydown', (e) => { if (e.key === 'Escape' && lb.classList.contains('is-open')) close(); });
    return lb;
  }
  $$('[data-gallery-main], [data-zoom]').forEach((img) => {
    img.setAttribute('tabindex', '0');
    img.setAttribute('role', 'button');
    const open = () => {
      const lb = buildLightbox();
      const full = img.getAttribute('data-zoom-src') || (img.currentSrc || img.src);
      lb.querySelector('img').src = full;
      lb._opener = img;
      lb.classList.add('is-open');
      const cls = lb.querySelector('.lightbox__close');
      if (cls) cls.focus();
    };
    img.addEventListener('click', open);
    img.addEventListener('keydown', (e) => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); open(); } });
  });

  /*----------------------------------------------- Quick-add --------*/
  /* Împachetat în initQuickAdd(scope) ca să poată fi re-rulat pe cardurile
     adăugate dinamic de feed-ul cu scroll infinit (vezi mai jos). */
  const initQuickAdd = (scope = document) => $$('.quick-add', scope).forEach((qa) => {
    // Idempotență: initQuickAdd rulează din mai multe locuri (boot, feed, wishlist) —
    // fără guard, un nod legat de două ori ar dubla add-urile și ar anula toggle-ul.
    if (qa.dataset.qaBound) return;
    qa.dataset.qaBound = '1';
    const trigger = $('.quick-add__trigger', qa);
    const panel = $('.quick-add__panel', qa);
    const sizesWrap = $('.quick-add__sizes', qa);
    const dataEl = $('[data-card-variants]', qa);
    let variants = [];
    try { variants = dataEl ? JSON.parse(dataEl.textContent) : []; } catch (e) {}
    let built = false;
    const build = () => {
      if (built || !sizesWrap) return;
      built = true;
      variants.forEach((v) => {
        const b = document.createElement('button');
        b.type = 'button';
        b.className = 'quick-add__size';
        b.textContent = v.title.length > 14 ? v.title.slice(0, 13) + '…' : v.title;
        if (!v.available) b.disabled = true;
        b.addEventListener('click', async (ev) => {
          ev.stopPropagation();
          b.disabled = true;
          try {
            const res = await fetch(ROOT + 'cart/add.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
              body: JSON.stringify({ id: v.id, quantity: 1 }),
            });
            if (!res.ok) throw new Error('add');
            if (window.refreshCart) await window.refreshCart();
            openCart();
            qa.classList.remove('is-open');
          } catch (err) {
            const card = qa.closest('[data-product-card]');
            const link = card && card.querySelector('[data-product-card-link]');
            location.href = link ? link.href : '/cart';
          }
          finally { b.disabled = !v.available ? true : false; }
        });
        sizesWrap.appendChild(b);
      });
    };
    const onTrigger = (e) => {
      e.preventDefault();
      if (variants.length <= 1) {
        // un singur variant -> add direct
        const v = variants[0];
        if (v) fetch(ROOT + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ id: v.id, quantity: 1 }) })
          .then((res) => { if (!res.ok) throw new Error('add'); return window.refreshCart && window.refreshCart(); })
          .then(() => openCart())
          .catch(() => {
            const card = qa.closest('[data-product-card]');
            const link = card && card.querySelector('[data-product-card-link]');
            location.href = link ? link.href : '/cart';
          });
        return;
      }
      build();
      qa.classList.toggle('is-open');
    };
    if (trigger) trigger.addEventListener('click', onTrigger);
    const qaCard = qa.closest('[data-product-card]');
    const mobileTrigger = qaCard ? qaCard.querySelector('[data-quick-add-open]') : null;
    if (mobileTrigger) mobileTrigger.addEventListener('click', onTrigger);
    // Desktop: construiește mărimile la hover ca să apară DIRECT în panou (cerere client
    // 2026-07-22). Panoul e afișat pe hover din CSS; build() e idempotent.
    if (qaCard) qaCard.addEventListener('mouseenter', build);
  });
  // Un singur listener delegat pentru închiderea panourilor quick-add la click
  // în afară — initQuickAdd rulează repetat pe cardurile adăugate de feed și
  // ar acumula listeneri pe document dacă l-am înregistra per card.
  document.addEventListener('click', (e) => {
    $$('.quick-add.is-open').forEach((qa) => {
      if (qa.contains(e.target)) return;
      const card = qa.closest('[data-product-card]');
      const mobileTrigger = card ? card.querySelector('[data-quick-add-open]') : null;
      if (mobileTrigger && (e.target === mobileTrigger || mobileTrigger.contains(e.target))) return;
      qa.classList.remove('is-open');
    });
  });
  initQuickAdd();
  // #1 (2026-07-23): expus pe window pt. cardurile construite în JS pe pagina
  // de wishlist (scriptul inline din sections/wishlist.liquid îl re-rulează).
  window.ctInitQuickAdd = initQuickAdd;

  /*------------------------- Carusel imagini card (drag + indicator) --------*/
  /* Feedback Figma #3: drag stânga-dreapta prin imagini fără a intra pe
     pagina produsului; bara de jos arată poziția în carusel.
     Împachetat în initCardCarousel(scope) pentru cardurile adăugate de feed.
     Un singur listener de resize la nivel de modul — fiecare init își împinge
     update-ul în listă, ca re-init-urile din feed să nu acumuleze listeneri. */
  const carouselResizeFns = [];
  window.addEventListener('resize', () => carouselResizeFns.forEach((fn) => fn()));
  const initCardCarousel = (scope = document) => $$('[data-card-carousel]', scope).forEach((car) => {
    const track = $('[data-card-track]', car);
    if (!track) return;
    const dash = $('[data-card-dash]', car);        // bară continuă (galeria PDP mobil)
    const segs = $$('[data-card-dash-seg]', car);   // nav-points segmentate (#3, 2026-07-23)
    const slides = track.children.length;
    // Hidratare leneșă (#3): slide-urile 2+ vin cu data-src (placeholder SVG în src);
    // încărcăm imaginile reale la prima interacțiune cu cardul, nu la load.
    let hydrated = false;
    const hydrate = () => {
      if (hydrated) return;
      hydrated = true;
      $$('img[data-src]', track).forEach((img) => {
        img.src = img.dataset.src;
        if (img.dataset.srcset) img.srcset = img.dataset.srcset;
        img.removeAttribute('data-src'); img.removeAttribute('data-srcset');
      });
    };
    ['pointerenter', 'touchstart', 'focusin'].forEach((ev) =>
      car.addEventListener(ev, hydrate, { once: true, passive: true }));
    if (slides > 1 && (dash || segs.length)) {
      const update = () => {
        if (dash) {
          const max = track.scrollWidth - track.clientWidth;
          const progress = max > 0 ? track.scrollLeft / max : 0;
          dash.style.transform = 'translateX(' + (progress * (slides - 1) * 100) + '%)';
        }
        if (segs.length) {
          const i = Math.min(slides - 1, Math.max(0, Math.round(track.scrollLeft / Math.max(1, track.clientWidth))));
          segs.forEach((s, k) => s.classList.toggle('is-active', k === i));
          // Doar slide-ul vizibil rămâne focusabil (slide-urile sunt <a> pe carduri)
          Array.prototype.forEach.call(track.children, (slide, k) => {
            if (slide.tagName !== 'A') return;
            if (k === i) { slide.removeAttribute('aria-hidden'); slide.removeAttribute('tabindex'); }
            else { slide.setAttribute('aria-hidden', 'true'); slide.setAttribute('tabindex', '-1'); }
          });
        }
      };
      track.addEventListener('scroll', () => { hydrate(); update(); }, { passive: true });
      carouselResizeFns.push(update);
      update();
    }
    // Săgeți pe hover desktop (#3). Fără stopPropagation: click-ul trebuie să ajungă
    // la listenerul delegat de pe document care închide panourile quick-add deschise.
    $$('[data-card-nav]', car).forEach((btn) => {
      btn.addEventListener('click', (e) => {
        e.preventDefault();
        hydrate();
        track.scrollBy({ left: (btn.getAttribute('data-card-nav') === 'prev' ? -1 : 1) * track.clientWidth, behavior: 'smooth' });
      });
    });
    // Drag cu mouse-ul pe desktop (pe touch merge scroll-ul nativ)
    let down = false, moved = false, startX = 0, startLeft = 0;
    const endDrag = () => {
      if (!down) return;
      down = false;
      setTimeout(() => { moved = false; track.classList.remove('is-drag'); }, 50);
    };
    track.addEventListener('pointerdown', (e) => {
      if (e.pointerType !== 'mouse') return;
      down = true; moved = false; startX = e.clientX; startLeft = track.scrollLeft;
      // NU capturăm pointerul la apăsare: setPointerCapture redirecta click-ul spre
      // track, așa că link-ul imaginii nu mai naviga la produs (fix client 2026-07-21).
      // Capturăm doar când chiar începe un drag (vezi pointermove).
    });
    track.addEventListener('pointermove', (e) => {
      if (!down) return;
      const dx = e.clientX - startX;
      if (Math.abs(dx) > 6 && !moved) {
        moved = true; track.classList.add('is-drag');
        try { track.setPointerCapture(e.pointerId); } catch (err) {}
      }
      if (moved) track.scrollLeft = startLeft - dx;
    });
    track.addEventListener('pointerup', endDrag);
    track.addEventListener('pointercancel', endDrag);
    // După drag nu navigăm către pagina produsului
    track.addEventListener('click', (e) => { if (moved) { e.preventDefault(); e.stopPropagation(); } }, true);
    track.addEventListener('dragstart', (e) => e.preventDefault());
  });
  initCardCarousel();

  /*------- Colecție: „Încarcă pagina următoare" → append + scroll infinit --------
     Cerere client 2026-07-21: link-ul făcea refresh (naviga la ?page=2); acum preia
     pagina următoare prin fetch și adaugă cardurile sub grilă, continuând scroll-ul.
     La eroare rămâne comportamentul clasic (linkul redevine navigabil). */
  $$('.collection-progress__more').forEach((link) => {
    const grid = $('.product-grid');
    const hrefHas = (a) => !!a && /[?&]page=\d+/.test(a);
    if (!grid || !hrefHas(link.getAttribute('href'))) return;
    const countEl = $('.collection-progress__count');
    let busy = false, done = false, io = null;
    const load = async () => {
      if (busy || done) return;
      busy = true; link.classList.add('is-loading');
      try {
        const res = await fetch(link.getAttribute('href'));
        if (!res.ok) throw new Error('page');
        const doc = new DOMParser().parseFromString(await res.text(), 'text/html');
        $$('.product-grid > li', doc).forEach((li) => {
          const node = document.importNode(li, true);
          grid.appendChild(node);
          initQuickAdd(node); initCardCarousel(node);
        });
        const nextEl = doc.querySelector('.collection-progress__more');
        const nextHref = nextEl ? nextEl.getAttribute('href') : null;
        const newCount = doc.querySelector('.collection-progress__count');
        if (countEl && newCount) countEl.textContent = newCount.textContent;
        if (hrefHas(nextHref)) { link.setAttribute('href', nextHref); }
        else { done = true; if (io) io.disconnect(); link.remove(); }
      } catch (e) { /* păstrează linkul clasic */ }
      busy = false; link.classList.remove('is-loading');
    };
    link.addEventListener('click', (e) => { e.preventDefault(); load(); });
    if ('IntersectionObserver' in window) {
      io = new IntersectionObserver((es) => { if (es.some((x) => x.isIntersecting)) load(); }, { rootMargin: '500px 0px' });
      io.observe(link);
    }
  });

  /*--------------- Eticheta „Culoare: X" urmărește selecția --------*/
  $$('.variant-group--color').forEach((group) => {
    const label = $('[data-option-value]', group);
    if (!label) return;
    $$('input[data-variant-option]', group).forEach((input) => {
      input.addEventListener('change', () => { label.textContent = input.value; });
    });
  });

  /*--------------------- Footer: coloane acordeon pe mobil --------*/
  $$('[data-foot-toggle]').forEach((btn) => {
    btn.addEventListener('click', () => {
      const col = btn.closest('[data-foot-col]');
      if (!col) return;
      const open = col.classList.toggle('is-open');
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  });

  /*------------ Feed produse: carusel cu scroll infinit ORIZONTAL (#9/#15) */
  /* Sentinela e ultimul <li> din banda orizontală (sections/rb-feed.liquid).
     Când intră în zona vizibilă a benzii (root = track, marjă pe orizontală),
     JS-ul cere paginile colecției (?page=N), preia <li>-urile din
     ul.product-grid al paginii de colecție și le inserează ÎNAINTEA
     sentinelei. Contorul de poziție (data-feed-offset) sare peste lotul
     inițial deja randat; dedup-ul pe URL normalizat e scoped PE BANDĂ
     (două feed-uri pe aceeași pagină se suprapun intenționat — rândul 2
     continuă de la al 6-lea). Stop la prima pagină goală sau după 3 erori. */
  $$('[data-feed-sentinel]').forEach((sentinel) => {
    const track = sentinel.closest('[data-feed-track]');
    const feedSection = sentinel.closest('.rb-feed');
    if (!track || !('IntersectionObserver' in window)) return;
    const more = feedSection ? $('.rb-feed__more', feedSection) : null;
    const feedUrl = sentinel.getAttribute('data-feed-url') || '/collections/all';
    let skip = parseInt(sentinel.getAttribute('data-feed-offset'), 10) || 0;
    let page = 1;
    let busy = false;
    let done = false;
    let fails = 0;
    // Cheie stabilă indiferent de prefixul /collections/<handle> din URL.
    const norm = (p) => { const i = p.indexOf('/products/'); return i >= 0 ? p.slice(i) : p; };
    const seen = new Set();
    $$('[data-product-card-link]', track).forEach((a) => seen.add(norm(a.pathname)));
    const stop = () => { done = true; io.disconnect(); sentinel.classList.remove('is-loading'); if (more) more.removeAttribute('hidden'); };
    const loadPage = async () => {
      const res = await fetch(feedUrl + '?page=' + page);
      if (!res.ok) throw new Error('feed');
      const html = await res.text();
      const doc = new DOMParser().parseFromString(html, 'text/html');
      fails = 0;
      const items = $$('ul.product-grid > li', doc);
      if (!items.length) { stop(); return 0; }
      let appended = 0;
      items.forEach((li) => {
        if (skip > 0) { skip -= 1; return; }
        const link = li.querySelector('[data-product-card-link]');
        const key = link ? norm(new URL(link.getAttribute('href'), location.origin).pathname) : null;
        if (key && seen.has(key)) return;
        if (key) seen.add(key);
        const node = document.importNode(li, true);
        node.classList.add('rb-feed__item');
        track.insertBefore(node, sentinel);
        initQuickAdd(node);
        initCardCarousel(node);
        appended += 1;
      });
      page += 1;
      return appended;
    };
    const io = new IntersectionObserver(async (entries) => {
      if (done || busy || !entries.some((en) => en.isIntersecting)) return;
      busy = true;
      sentinel.classList.add('is-loading');
      try {
        // Repetă cât timp pagina cerută a fost consumată integral de skip/dedup.
        let appended = 0;
        while (!done && appended === 0) appended = await loadPage();
      } catch (err) {
        fails += 1;
        if (fails >= 3) stop();
        else await new Promise((r) => setTimeout(r, 1000 * fails));
      } finally {
        busy = false;
        sentinel.classList.remove('is-loading');
        if (!done) {
          // Reevaluează sentinela: dacă a rămas vizibilă în bandă, continuă.
          io.unobserve(sentinel);
          io.observe(sentinel);
        }
      }
    }, { root: track, rootMargin: '0px 600px' });
    io.observe(sentinel);
  });
})();
